module.exports = __webpack_public_path__ + "media/images/pokerroom/redstar/step2-pict01-full-7373aa83ef96350578f72d9eb8df15a2.jpg";